import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
// components
import ModalRegister from "../../components/modal/ModalRegister/ModalRegister";
// utils
import { api } from "../../utils/api";
//services
import { getBond } from "../../services/GeneralRegistration/getBond";
import { getUser } from "../../services/GeneralRegistration/getUser";
//context
import { useAppContext } from "../../context/AppContext";
import { cancelBond } from "../../services/GeneralRegistration/postCancelBond";

const ModalGeneralRegister = ({ onHide, visible, editClient }) => {
  const { permissions } = useAppContext();
  const modalRef = useRef();
  const [file, setFile] = useState(null);
  const [bond, setBond] = useState(null);
  const [access, setAccess] = useState(null);
  const [spouse, setSpouse] = useState(null);
  const [accessId, setAccessId] = useState(null);
  const [emailSend, setEmailSend] = useState(false);
  const [emailVerify, setEmailVerify] = useState(false);
  const [address, setAddress] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [telephones, setTelephones] = useState([]);
  const [personalData, setPersonalData] = useState(null);
  const [showInputCrc, setShowInputCrc] = useState(false);
  const [typeRegister, setTypeRegister] = useState("fisica");
  const [showInputCreci, setShowInputCreci] = useState(false);

  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [errorsVisible, setErrorsVisible] = useState(false);

  function getFalseBondIds(data) {
    return Object.keys(data)
      .filter((key) => key.startsWith("bond_id-") && data[key] === false)
      .map((key) => key.split("-")[1]);
  }

  function removeBondIds(data) {
    Object.keys(data).forEach((key) => {
      if (key.startsWith("bond_id-")) {
        delete data[key];
      }
    });
  }

  const handleSubmit = async (data) => {
    setLoading(true);
    const notification = toast.loading("Salvando dados...");

    try {
      const response = await api.post("register-general", data);

      if (response.data) {
        toast.update(notification, {
          render: response.data.success,
          autoClose: 1500,
          type: "success",
          isLoading: false,
        });
      }
      onHide();
      setAccess(null);
      setFile(null);
      setBond(null);
      setSpouse(null);
      setEmailSend(false);
      setEmailVerify(false);
      setAddress(null);
      setContacts([]);
      setDocuments([]);
      setTelephones([]);
      setPersonalData(null);
      setTypeRegister("fisica");
      setErrors(null);
      setLoading(false);
    } catch (e) {
      setErrors(e.response?.data?.errors);
      setErrorsVisible(true);
      toast.update(notification, {
        render: "Falha ao salvar informações!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      throw e;
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (data, bond) => {
    setLoading(true);
    const notification = toast.loading("Atualizando dados...");
    if (permissions && permissions.includes("8") && bond) {
      const falseBondIds = getFalseBondIds(bond);
      const objBond = {
        ids: falseBondIds,
      };

      if (falseBondIds.length > 0) {
        cancelBond(objBond);
      }

      removeBondIds(bond);
    }
    try {
      const response = await api.put(`register-general/${editClient}`, data);
      toast.update(notification, {
        render: "Dados atualizados com sucesso!",
        autoClose: 1500,
        type: "success",
        isLoading: false,
      });
      onHide();
      setAccess(null);
      setFile(null);
      setBond(null);
      setEmailSend(false);
      setEmailVerify(false);
      setSpouse(null);
      setAddress(null);
      setContacts([]);
      setDocuments([]);
      setTelephones([]);
      setPersonalData(null);
      setTypeRegister("fisica");
      setErrors(null);
      setLoading(false);
    } catch (e) {
      console.log("erro: ", e.response.data.errors);
      setErrors(e.response.data.errors);
      setErrorsVisible(true);
      toast.update(notification, {
        render: "Falha ao atualizar informações!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      throw e;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (editClient) {
        setLoadingModal(true);
        const response = await getUser(editClient);
        // console.log(response);
        if (response.message) {
          toast.error("Houve um problema para buscar os dados");
          onHide();
          return;
        }
        if (permissions && permissions.includes("8")) {
          const responseBond = await getBond(editClient);
          if (responseBond) {
            setBond(responseBond);
          }
        }
        setEmailVerify(response.email_verified === 1);
        setEmailSend(response.role !== null);
        const parsedAccess = {
          registration_types: response.registration_types.map((t) => ({
            name: t.name,
            code: t.id,
          })),
          status: response.status,
          access_id: response.role?.id || null,
          email: response.email,
          confirmEmail: response.email,
          creci: response.creci || "",
          crc: response.crc || "",
        };
        setAccessId(response.role?.id || null);
        setAccess(parsedAccess);

        const parsedPersonalData = {
          doc: response.doc,
          name: response.name,
          rg: response.rg,
          type_doc: response.type_doc,
          date_of_birth: response.date_of_birth,
          nationality: response.nationality,
          profession: response.profession,
          issuing_authority: response.issuing_authority,
          date_issuing_authority: response.date_issuing_authority,
          state_registration: response.state_registration,
          municipal_registration: response.municipal_registration,
          cod_inc_trib: response.cod_inc_trib,
          name_mother: response.name_mother,
          name_father: response.name_father,
          family_income: response.family_income,
          marital_status: response.marital_status,
          spouse_id: response.spouse?.id,
          obs: response.obs,
          contacts:
            response.contacts?.map((c) => ({
              number: c.number,
              type_number: c.type_number,
            })) || [],
        };

        // Define o typeRegister ANTES de definir os personalData para evitar conflitos
        console.log("ModalGeneralRegister - response.type_doc:", response.type_doc);
        if (response.type_doc === 1) {
          console.log("ModalGeneralRegister - Definindo typeRegister como 'fisica'");
          setTypeRegister("fisica");
        } else {
          console.log("ModalGeneralRegister - Definindo typeRegister como 'juridica'");
          setTypeRegister("juridica");
        }

        console.log("ModalGeneralRegister - parsedPersonalData:", parsedPersonalData);
        setPersonalData(parsedPersonalData);

        setContacts(response.contacts);
        setTelephones(response.contacts);
        const profile = response.documents.find(
          (item) => item.type_file === "cadastro_geral_profile_photo"
        );
        // console.log(profile);
        setFile(profile && profile.path);
        if (response.spouse !== null) {
          setSpouse({
            id: response.spouse.id,
            doc: response.spouse.doc,
            name: response.spouse.name,
          });
        } else {
          setSpouse("");
        }
        if (response.address) {
          setAddress({
            cep: response.address.cep,
            address: response.address.address,
            num: response.address.num,
            complement: response.address.complement,
            city: response.address.city,
            state: response.address.state,
            neighborhood: response.address.neighborhood,
          });
        }

        if (response.documents && response.documents.length > 0) {
          setDocuments(response.documents);
        }
        setLoadingModal(false);
      }
    };
    fetchData();
  }, [editClient]);

  return (
    <>
      <ModalRegister
        file={file}
        bond={bond}
        ref={modalRef}
        access={access}
        onHide={() => {
          onHide();
          setAccess(null);
          setFile(null);
          setBond(null);
          setSpouse(null);
          setAddress(null);
          setEmailSend(false);
          setEmailVerify(false);
          setContacts([]);
          setDocuments([]);
          setTelephones([]);
          setPersonalData(null);
          setTypeRegister("fisica");
          setErrors(null);
          setLoading(false);
        }}
        spouse={spouse}
        errors={errors}
        setFile={setFile}
        address={address}
        setBond={setBond}
        loading={loading}
        visible={visible}
        accessId={accessId}
        contacts={contacts}
        emailSend={emailSend}
        setAccess={setAccess}
        documents={documents}
        setSpouse={setSpouse}
        editClient={editClient}
        setAddress={setAddress}
        telephones={telephones}
        emailVerify={emailVerify}
        setContacts={setContacts}
        handleUpdate={handleUpdate}
        loadingModal={loadingModal}
        personalData={personalData}
        setDocuments={setDocuments}
        typeRegister={typeRegister}
        handleSubmit={handleSubmit}
        showInputCrc={showInputCrc}
        setTelephones={setTelephones}
        errorsVisible={errorsVisible}
        showInputCreci={showInputCreci}
        setShowInputCrc={setShowInputCrc}
        setTypeRegister={setTypeRegister}
        setPersonalData={setPersonalData}
        setErrorsVisible={setErrorsVisible}
        setShowInputCreci={setShowInputCreci}
      />
    </>
  );
};

export default ModalGeneralRegister;
